var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ordersListNewLayoutEnabled
    ? _c("orders-list")
    : _c(
        "div",
        [
          _vm.showFilter
            ? _c("new-filter", {
                ref: "newFilter",
                attrs: {
                  origin: "orders",
                  options: _vm.filterOptionsOrders,
                  additionalOptions: _vm.additionalOptions,
                  loadingList: _vm.loadingListOrders,
                  action: _vm.action,
                  sendFilterEvents: true,
                },
              })
            : _vm._e(),
          _vm.report.alert.show
            ? _c(
                "emd-alert",
                {
                  attrs: {
                    "data-testid": "alert_export_report_orders",
                    variant: _vm.report.alert.variant,
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.report.alert.show = false
                    },
                  },
                },
                [
                  _c("template", { slot: "content" }, [
                    _c("p", [_vm._v(_vm._s(_vm.$t(_vm.report.alert.title)))]),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _c(
            "orders-table",
            { attrs: { action: _vm.action } },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "emd-card-header",
                    [
                      _c("h2", { staticClass: "emd-text _size_section" }, [
                        _vm._v(_vm._s(_vm.$t("order.list.title"))),
                      ]),
                      _c(
                        "template",
                        { slot: "actions" },
                        [
                          _c("report-button", {
                            attrs: {
                              loadingList: _vm.loadingListOrders,
                              report: _vm.report,
                              totalListItems: _vm.totalListItems,
                            },
                          }),
                          _vm.canShowShop
                            ? _c(
                                "jade-button",
                                {
                                  attrs: {
                                    "data-testid": "btn_create_order",
                                    id: "link-shop-orders",
                                    icon: "plus",
                                    size: "small",
                                    variant: "primary-solid",
                                  },
                                  on: { click: _vm.openShop },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("btn-create")) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }